import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorMutationKeys } from '../../../keys'
import { UpdateMemberRequest, UpdateMemberResponse } from '../../../type'
import { updateMember } from '../../services'

interface UpdateMemberParams {
	id: string
	payload: UpdateMemberRequest
}

export default function useMutationUpdateMember(
	props?: UseBaseMutationOptions<UpdateMemberResponse, UpdateMemberParams>,
) {
	return useMutation({
		mutationKey: [OperatorMutationKeys.UpdateMember],
		mutationFn: (params) => updateMember(params.payload, params.id),
		...props,
	})
}
